const $ = require('jquery')
const R = require('ramda')
const Promise = require('bluebird')
const toastr = require('toastr')
const errorBlock = require('templates/error-block.hbs')

const skip = R.defaultTo(null)

const log = (a) => {
    console.log(a)
    return a
}

const pairObjectify = R.pipe(
    R.splitEvery(2),
    R.map(x => ({ key: R.head(x), value: R.last(x) }))
)

const hasNullable = R.any(
    R.both(
        R.pipe(
            R.prop(0),
            R.equals('nullable')
        ),
        R.prop(2)
    )
)

const hasFailure = R.pipe(
    R.values,
    R.map(
        R.ifElse(
            hasNullable,
            R.always(true),
            R.reduce((a, b) => a && b[2], true)
        )
    ),
    R.flatten,
    R.reduce(R.and, true),
    R.not
)

const hasFormFailure = R.pipe(
    R.values,
    R.filter(x => x.length > 0),
    R.length,
    R.lt(0)
)

// Kinda overkill and cryptic
const evalRules = R.pipe(
    R.ifElse(
        R.is(String),
        R.split(/\|/),
        skip
    ),
    R.ifElse(
        R.is(Array),
        R.pipe(
            R.map(
                R.ifElse(
                    R.is(String),
                    R.split(/:/),
                    skip
                )
            )
        ),
        skip
    ),
    R.map(([key, value]) => {
        return [key, R.ifElse(
            R.isNil,
            R.defaultTo(null),
            R.ifElse(
                R.is(String),
                R.split(','),
                skip
            )
        )(value)]
    })
)

// const stringify = (value) => {
//     return value ? value.toString() : ''
// }

const isEmpty = (value) => R.isNil(value) || R.isEmpty(value)

const getField = (data, field, defaultValue = null) => {
    if (data === undefined || data === null || typeof data !== 'object' || !data.hasOwnProperty(field)) {
        return defaultValue
    }

    return data[field]
}

/**
 * Cuida da validação de dados,
 * a ideia é que a implementação seja identica ao do Laravel para
 * não haver redundancia de implementações
 *
 * NOTE: a performance é questionável
 */
/**
 * não utilizar a sintaxe:
 * key() {}
 * utilizar:
 * key: () => {}
 */
const validators = {
    /**
     * The field under validation must be yes, on, or 1.
     * This is useful for validating "Terms of Service" acceptance.
     */
    'accepted': value => true,

    /**
     * The field under validation must be a valid URL according to the checkdnsrr PHP function.
     */
    // "active_url": value => false,

    /**
     * The field under validation must be a value after a given date.
     * The dates will be passed into the PHP strtotime function.
     */
    'after': (value, data, ref) => true,

    /**
     * The field under validation must be entirely alphabetic characters.
     */
    'alpha': (value, data) => true,

    /**
     * The field under validation may have alpha-numeric characters, as well as dashes and underscores.
     */
    'alpha_dash': (value, data) => true,

    /**
     * The field under validation must be entirely alpha-numeric characters.
     */
    'alpha_num': (value, data) => true,

    /**
     * he field under validation must be of type array.
     */
    'array': (value, data) => true,

    /**
     * The field under validation must be a value preceding the given date.
     * The dates will be passed into the PHP strtotime function.
     */
    'before': (value, data, ref) => true,

    /**
     * The field under validation must have a size between the given min and max.
     * Strings, numerics, and files are evaluated in the same fashion as the size rule.
     */
    'between': (value, data, min, max) => true,

    /**
     * The field under validation must be able to be cast as a boolean.
     * Accepted input are true, false, 1, 0, "1" and "0".
     */
    'boolean': (value, params, data) => true,

    /**
     * The field under validation must have a matching field of foo_confirmation.
     * For example, if the field under validation is password,
     * a matching password_confirmation field must be present in the input.
     */
    'confirmed': (value, params, data) => true,

    /**
     * The field under validation must be a valid date according to the strtotime PHP function.
     */
    'date': (value, params, data) => true,

    /**
     * The field under validation must match the format defined according to the date_parse_from_format PHP function.
     */
    'date_format': (value, data, format) => true,

    /**
     * The given field must be different than the field under validation.
     */
    'different': (value, data, ref) => true,

    /**
     * The field under validation must be numeric and must have an exact length of value.
     */
    'digits': (value, data, len) => true,

    /**
     * The field under validation must have a length between the given min and max.
     */
    'digits_between': (value, data, min, max) => true,

    /**
     * The field under validation must be formatted as an e-mail address.
     *
     * RegExp obtained here https://github.com/php/php-src/blob/master/ext/filter/logical_filters.c#L575
     */
    /* eslint-disable */
    'email': (value, data) => /^(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){255,})(?!(?:(?:\x22?\x5C[\x00-\x7E]\x22?)|(?:\x22?[^\x5C\x22]\x22?)){65,}@)(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22))(?:\.(?:(?:[\x21\x23-\x27\x2A\x2B\x2D\x2F-\x39\x3D\x3F\x5E-\x7E]+)|(?:\x22(?:[\x01-\x08\x0B\x0C\x0E-\x1F\x21\x23-\x5B\x5D-\x7F]|(?:\x5C[\x00-\x7F]))*\x22)))*@(?:(?:(?!.*[^.]{64,})(?:(?:(?:xn--)?[a-z0-9]+(?:-[a-z0-9]+)*\.){1,126}){1,}(?:(?:[a-z][a-z0-9]*)|(?:(?:xn--)[a-z0-9]+))(?:-[a-z0-9]+)*)|(?:\[(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){7})|(?:(?!(?:.*[a-f0-9][:\]]){7,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,5})?)))|(?:(?:IPv6:(?:(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){5}:)|(?:(?!(?:.*[a-f0-9]:){5,})(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3})?::(?:[a-f0-9]{1,4}(?::[a-f0-9]{1,4}){0,3}:)?)))?(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))(?:\.(?:(?:25[0-5])|(?:2[0-4][0-9])|(?:1[0-9]{2})|(?:[1-9]?[0-9]))){3}))\]))$/i.exec(value) !== null,
    /* eslint-enable */

    /**
     * The field under validation must exist on a given database table.
     */
    'exists': (value, data) => true,

    /**
     * The file under validation must be an image (jpeg, png, bmp, or gif)
     */
    // "image": (value, data) => false,

    /**
     * The field under validation must be included in the given list of values.
     */
    'in': (value, data, ...values) => true,

    /**
     * The field under validation must have an integer value.
     */
    'integer': (value, data) => true,

    /**
     * The field under validation must be formatted as an IP address.
     */
    'ip': (value, data) => true,

    /**
     * The field under validation must be less than or equal to a maximum value.
     * Strings, numerics, and files are evaluated in the same fashion as the size rule.
     */
    'max': (value, data, ref) => true,

    /**
     * The file under validation must have a MIME type corresponding to one of the listed extensions.
     */
    // "mimes": (value, data) => false,

    /**
     * The field under validation must have a minimum value.
     * Strings, numerics, and files are evaluated in the same fashion as the size rule.
     */
    'min': (value, data, ref) => true,

    /**
     * The field under validation must not be included in the given list of values.
     */
    'not_in': (value, data, values) => true,

    /**
     * The field under validation must have a numeric value.
     */
    'numeric': (value, data) => /^(?:[-+]?(?:[0-9]+))?(?:\.[0-9]*)?(?:[eE][\+\-]?(?:[0-9]+))?$/.test(String(value)),

    /**
     * The field under validation must match the given regular expression.
     */
    'regex': (value, data, pattern) => !!value.match(pattern),

    /**
     * The field under validation must be present in the input data.
     */
    'required': value => !isEmpty(value),

    /**
     * The field under validation must be present if the field field is equal to any value.
     * @todo zip resolves?
     */
    'required_if': (value, data, ...params) => R.pipe(
        pairObjectify,
        R.map((item) => (data[item.key] !== null && data[item.key] === item.value) ? (!R.isNil(value) && !R.isEmpty(value)) : true),
        R.values,
        R.reduce(R.and, true)
    )(params),

    /**
     * The field under validation must be present only if any of the other specified fields are present.
     */
    'required_with': (value, data, ...fields) => true,

    /**
     * The field under validation must be present only if all of the other specified fields are present.
     */
    'required_with_all': (value, data, ...fields) => true,

    /**
     * The field under validation must be present only when any of the other specified fields are not present.
     */
    'required_without': (value, data, field) => {
        if (!getField(data, field)) {
            return !isEmpty(value)
        }

        return true
    },

    /**
     * The field under validation must be present only when the all of the other specified fields are not present.
     */
    'required_without_all': (value, data, ...fields) => true,

    /**
     * The given field must match the field under validation.
     */
    'same': (value, data, field) => data[field] === value,

    /**
     * The field under validation must have a size matching the given value.
     * For string data, value corresponds to the number of characters.
     * For numeric data, value corresponds to a given integer value.
     * For files, size corresponds to the file size in kilobytes.
     */
    'size': (value, data, ref) => true,

    /**
     * The field under validation must be a string type.
     */
    'string': (value, data) => true,

    /**
     * The field under validation must be a valid timezone identifier according to the timezone_identifiers_list PHP function.
     */
    'timezone': (value, data) => true,

    /**
     * The field under validation must be unique on a given database table. If the column option is not specified, the field name will be used.
     *
     * NOTE, no verification is made here, it's just bypasses.
     */
    'unique': (value, data) => true,

    /**
     * The field under validation must be formatted as an URL.
     */
    'url': (value, data) => /^(https?|ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value),

    'really_not_empty': (value, data) => !isEmpty(value),

    'm_unique': (value, data) => true,
    'instance_unique': (value, data) => true,

    'test-promise': (value, data) => new Promise((resolve, reject) => {
        setTimeout(_ => resolve(true), 1000)
    }),

    'br_phones': (value, data) => /^[0-9]{10,11}$/.test(value) || /^[0-9]{2}\*[0-9]{1,7}\*[0-9]{2,5}$/.test(value),

    'nullable': (value) => isEmpty(value),

    'not_empty_without': (value) => true,

    'valid_implicit': (value) => true,

    'unique_without_trashed': (value) => true
}

class ValidationError extends Error {
    constructor (data) {
        super('Ocorreu um erro na validação')
        this.data = data
        this.skip = true
    }
}

const defaultMessages = {
    'accepted': '',
    'after': '',
    'alpha': '',
    'alpha_dash': '',
    'alpha_num': '',
    'array': '',
    'before': '',
    'between': '',
    'boolean': '',
    'confirmed': '',
    'date': '',
    'date_format': '',
    'different': '',
    'digits': '',
    'digits_between': '',
    'email': 'E-mail inválido',
    'in': '',
    'integer': '',
    'ip': '',
    'max': '',
    'min': '',
    'not_in': '',
    'numeric': 'O campo $field deve ser numérico',
    'regex': '',
    'required': 'O campo $field é obrigatório',
    'required_if': 'O campo $field é obrigatório',
    'required_with': 'O campo $field é obrigatório',
    'required_with_all': '',
    'required_without': 'O campo $field é obrigatório',
    'required_without_all': '',
    'same': 'Os campos devem ser iguais',
    'size': '',
    'string': '',
    'timezone': '',
    'url': 'URL inválida',
    'br_phones': 'Telefone Inválido'
}

const nameIt = (formName, fieldName) => [formName, fieldName].filter(_ => !!_).join('.')

/**
 * @constructor
 */
const Validator = function Validator (_rules, customMessages = null, attributes = null) {
    let rules = _rules

    if (customMessages == null && attributes == null) {
        if (rules.hasOwnProperty('attributes') && rules.hasOwnProperty('messages') && rules.hasOwnProperty('rules')) {
            rules = _rules.rules || {}
            customMessages = _rules.messages || {}
            attributes = _rules.attributes || {}
        } else {
            customMessages = {}
            attributes = {}
        }
    }

    const messages = { ...defaultMessages, ...customMessages }

    const parsedRules = R.mapObjIndexed(value => evalRules(value), rules)

    this.translateField = field => attributes[field] || field

    this.validateRule = R.curryN(2, (rule, value, data = null, ...params) => {
        if (validators.hasOwnProperty(rule)) {
            return validators[rule].apply(validators, [value, data].concat(params))
        }

        if (window.rescue) {
            window.rescue.error(`Rule ${rule} doesn't exists.`)
        }

        return true
    })

    this.throw = (form, field, message, loud = false) => {
        const $form = $(form)

        const formName = $form.attr('name') || $form.attr('data-name')

        const inputName = `${formName}.${field}`

        const $input = $form
            .find(`[data-field="${inputName}"], [name="${inputName}"]`)

        const $group = $input.closest('.form-group')

        $group
            .find('.error-bag')
            .remove()

        $group
            .removeClass('has-validation-errors')
            .removeClass('alert')
            .removeClass('alert-warning')

        $group
            .addClass('has-validation-errors')
            .append(errorBlock({ ...{ message, field }, loud }))

        if (loud) {
            $group.addClass('alert alert-warning')
        }

        throw new ValidationError(null)
    }

    // this.also = (alias, field, message, fn) => {
    //     const name = `${alias}.${field}`
    //
    //     validators[name] = fn
    //     messages[name] = message
    //
    //     if (parsedRules.hasOwnProperty(field)) {
    //         parsedRules[field].push(fn)
    //     } else {
    //         parsedRules[field] = [fn]
    //     }
    //
    //     return this
    // }

    this.getMessage = (rule, field, params) => {
        let message = null

        if (messages.hasOwnProperty(`${field}.${rule}`)) {
            message = messages[`${field}.${rule}`]
        } else if (messages.hasOwnProperty(rule)) {
            message = messages[rule]
        } else if (messages.hasOwnProperty(field)) {
            message = messages[field]
        } else {
            return `O campo ${field} não obedeceu a regra ${rule}`
        }

        if (typeof message === 'function') {
            return message(field, rule, params)
        }

        return message
            .replace('$field', this.translateField(field))
    }

    this.validate = (data, context = null) => {
        return Promise.props(R.mapObjIndexed((rules, field) => {
            return Promise.map(rules, ([rule, params]) => {
                return Promise.resolve(this.validateRule.apply(this, [rule, data[field], data].concat(params)))
                    .then(result => {
                        return [rule, params, result]
                    })
            })
        }, parsedRules)).then(result => {
            const messages = R.pipe(
                R.mapObjIndexed((result, field) => {
                    return result.filter(([rule, params, result]) => {
                        if (rule === 'nullable') {
                            return false
                        }

                        return !result
                    }).map(([rule, params, result]) => {
                        return this.getMessage(rule, field, params)
                    })
                }),
                R.pickBy((value, key) => value.length > 0)
            )(result)

            return {
                result,
                messages: R.zipObj(R.map(x => `${nameIt(context, x)}`, R.keys(messages)), R.values(messages))
            }
        }).then(f => {
            if (hasFailure(f.result)) {
                return Promise.reject(new ValidationError(f.messages))
            } else {
                return Promise.resolve(f.result)
            }
        })
    }

    this.clearFormErrors = ($form) => {
        $form
            .find('.error-bag')
            .remove()

        $form
            .find('.form-group')
            .removeClass('has-validation-errors')
            .removeClass('alert')
            .removeClass('alert-warning')

        return this
    }

    this.validateForm = (form, data, focus = true) => {
        const $form = $(form)

        const formName = $form.attr('name') || $form.attr('data-name')

        return this
            .validate(data, formName)
            .then(data => {
                $form
                    .find('.error-bag')
                    .remove()

                $form
                    .find('.form-group')
                    .removeClass('has-validation-errors')
                    .removeClass('alert')
                    .removeClass('alert-warning')
                return data
            })
            .catch(ex => {
                const errors = ex.data

                $form
                    .find('.error-bag')
                    .remove()

                $form
                    .find('.form-group')
                    .removeClass('has-validation-errors')
                    .removeClass('alert')
                    .removeClass('alert-warning')

                const $inputs = []
                const $formInputs = $form.find('[data-field]')

                R.toPairs(errors)
                    .map(([field, errors]) => [field, [errors.slice(0).shift()]])
                    .forEach(function ([field, errors]) {
                        errors.forEach((message) => {
                            if (field === 'global') {
                                toastr.error(message)
                                return
                            }

                            const $input = $form
                                .find(`[data-field="${field}"], [name="${field}"]`)

                            const loud = $input.hasClass('loud-error')

                            $inputs.push({
                                position: $formInputs.index($input),
                                el: $input
                            })

                            const $group = $input.closest('.form-group')

                            $group
                                .addClass('has-validation-errors')
                                .append(errorBlock({ ...{ message, field }, loud }))

                            if (loud) {
                                $group.addClass('alert alert-warning')
                            }
                        })
                    })

                if (focus) {
                    const $focusOn = $inputs.sort((a, b) => {
                        return a.position > b.position
                    })[0]

                    if ($focusOn) {
                        $focusOn.el.focus()
                    }
                }

                if (hasFormFailure(errors)) {
                    return Promise.reject(new ValidationError(errors))
                }

                return Promise.resolve(true)
            })
    }
}

Validator.addRule = (name, fn) => {
    validators[name] = fn
}

module.exports = Validator



// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/helpers/validator.js